export const categories = [
  { slug: 'wanghong-tafang', name: '网红塌房', icon: 'ri-alert-fill', description: '网红主播翻车塌房黑料全收录' },
  { slug: 'zhubo-heiliao', name: '主播黑料', icon: 'ri-spy-fill', description: '各大平台主播不为人知的秘密' },
  { slug: 'meiri-dagua', name: '每日大瓜', icon: 'ri-fire-fill', description: '每天最新最热的吃瓜爆料' },
  { slug: 'shishi-zhuizong', name: '实时追踪', icon: 'ri-radar-fill', description: '热点事件持续跟进报道' },
  { slug: 'bagua-shendu', name: '八卦深度', icon: 'ri-search-eye-fill', description: '深度挖掘娱乐圈内幕真相' },
  { slug: 'chigua-baoliao', name: '吃瓜爆料', icon: 'ri-chat-smile-2-fill', description: '网友投稿第一手爆料资讯' },
];

export interface Article {
  slug: string;
  title: string;
  excerpt: string;
  content: string;
  category: string;
  author: string;
  authorAvatar: string;
  publishedAt: string;
  imageUrl: string;
  imagePrompt: string;
  tags: string[];
  views: number;
  comments: number;
  isHot: boolean;
  isBreaking: boolean;
}

export const articles: Article[] = [
  {
    slug: 'mouyin-daihuo-fanche',
    title: '某音千万粉丝女主播直播带货翻车，被曝售卖假货遭品牌方实锤',
    excerpt: '拥有1200万粉丝的某音头部女主播近日在直播带货中被品牌方当场实锤售卖假冒伪劣产品，引发全网热议。品牌方连夜发声明要求平台下架所有涉事商品，该主播账号已被平台暂时封禁...',
    content: `<p>近日，某音平台拥有超过1200万粉丝的头部女主播"甜心baby"在直播带货过程中遭遇了一场前所未有的翻车事件。据悉，该主播在推销一款宣称"原装进口"的高端护肤品时，被该品牌官方账号当场在评论区实锤为假冒产品。</p>
    <p>品牌方随后发布正式声明称，经鉴定，该主播所售产品的外包装、防伪标识、内容物质地均与正品存在明显差异，确认为假冒伪劣商品。品牌方已向平台投诉，要求立即下架所有涉事商品链接，并保留追究法律责任的权利。</p>
    <p>事件曝光后引发网友热议，不少曾经购买该产品的消费者纷纷在社交平台晒出购买记录，要求退款赔偿。据不完全统计，该场直播销售额超过800万元，涉及消费者数千人。</p>
    <p>目前，该主播账号已被平台暂时封禁处理。其经纪团队发布道歉声明称将全力配合调查，并对所有购买涉事产品的消费者进行先行赔付。</p>
    <blockquote><p>业内人士分析指出，直播带货行业乱象频出，假货问题已成为行业顽疾。平台方需要加强监管力度，建立更完善的商品审核机制，才能从根本上杜绝此类事件的发生。</p></blockquote>
    <p>截至发稿，该事件仍在持续发酵中。相关部门已介入调查，我们将持续关注事件进展。</p>`,
    category: 'wanghong-tafang',
    author: '吃瓜前线记者',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20news%20reporter%20avatar%20portrait%20with%20neutral%20expression%20minimal%20dark%20background%20editorial%20style&width=80&height=80&seq=avatar-journalist-01&orientation=squarish',
    publishedAt: '2026-07-07T10:30:00Z',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20dramatic%20dark%20cinematic%20scene%20of%20a%20livestreaming%20studio%20with%20broken%20ring%20light%20and%20shattered%20phone%20screen%20showing%20red%20alerts%20on%20dark%20background%20with%20dramatic%20red%20and%20black%20lighting%20moody%20atmosphere%20high%20contrast%20editorial%20photography&width=1600&height=900&seq=hero-livestream-scandal&orientation=landscape',
    imagePrompt: 'A dramatic dark cinematic scene of a livestreaming studio with broken ring light and shattered phone screen showing red alerts on dark background with dramatic red and black lighting moody atmosphere high contrast editorial photography',
    tags: ['直播带货', '假货', '某音', '翻车'],
    views: 128500,
    comments: 3621,
    isHot: true,
    isBreaking: true,
  },
  {
    slug: 'kuaishou-nanzhubo-ganqingzha',
    title: '快手男主播被曝同时交往多名女粉丝，聊天记录曝光内容不堪入目',
    excerpt: '快手某游戏区男主播被多名女粉丝联合爆料，指控其利用主播身份同时与多位女粉丝發展不正当关系，大量私密聊天记录被曝出，内容令人震惊...',
    content: `<p>快手平台某知名游戏区男主播"战神阿飞"近日被多名女粉丝联合曝光，指控其在过去两年间利用主播身份，同时与多位女粉丝保持不正当关系，并通过各种手段骗取钱财。</p>
    <p>据爆料者提供的聊天记录显示，该主播使用多个社交账号，对不同女粉丝使用相似的话术和套路。聊天内容涉及大量暧昧言论和金钱往来，其中最高一笔转账金额高达15万元。</p>
    <p>多名受害女粉丝表示，该主播在交往初期表现得温柔体贴，经常在直播中给予特殊关注，随后逐步发展线下关系。一旦对方要求确立正式关系或追讨借款，该主播便会以各种理由推脱甚至直接拉黑。</p>
    <p>事件在社交平台迅速发酵，话题#战神阿飞塌房#短时间内登上热搜榜首。大量网友涌入该主播直播间刷屏质问，直播被迫中断。</p>
    <blockquote><p>有法律界人士指出，如果聊天记录属实，该主播的行为可能涉及诈骗，建议受害女粉丝收集证据向公安机关报案。</p></blockquote>
    <p>截至目前，该主播尚未对爆料内容作出正式回应，其快手账号已设置私密。快手官方客服表示已关注此事，正在进行核实。</p>`,
    category: 'wanghong-tafang',
    author: '娱乐调查组',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Chinese%20investigative%20journalist%20portrait%20serious%20expression%20dark%20minimal%20background%20professional%20headshot&width=80&height=80&seq=avatar-investigator-02&orientation=squarish',
    publishedAt: '2026-07-06T18:45:00Z',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dark%20moody%20scene%20of%20a%20gaming%20streamer%20setup%20with%20multiple%20glowing%20phone%20screens%20displaying%20chat%20messages%20in%20red%20tones%20on%20dark%20background%20cinematic%20noir%20atmosphere%20with%20dramatic%20shadows&width=1600&height=900&seq=hero-relationship-scandal&orientation=landscape',
    imagePrompt: 'Dark moody scene of a gaming streamer setup with multiple glowing phone screens displaying chat messages in red tones on dark background cinematic noir atmosphere with dramatic shadows',
    tags: ['快手', '感情诈骗', '男主播', '塌房'],
    views: 96500,
    comments: 2847,
    isHot: true,
    isBreaking: false,
  },
  {
    slug: 'bilibili-meishi-boke-xuanguan',
    title: 'B站美食博主被曝视频全部摆拍，真实厨艺惨不忍睹遭前同事爆料',
    excerpt: '拥有500万粉丝的B站美食区up主"厨房达人酱"被前同事爆料，其所有精美美食视频均为团队精心布置的摆拍作品，本人真实厨艺极为糟糕...',
    content: `<p>B站美食区知名up主"厨房达人酱"近日遭遇了职业生涯最大危机。其前同事匿名爆料称，该up主所有视频中呈现的精美菜品和娴熟厨艺，实际上全部由专业厨师团队幕后操刀，而博主本人仅负责出镜念台词。</p>
    <p>爆料人提供了多张拍摄现场的幕后照片，清晰显示在摄像机拍不到的角落，有专业厨师正在进行食材准备和菜品制作。更有视频拍摄脚本显示，博主甚至连最基本的切菜动作都需要多次NG重拍。</p>
    <p>更令人震惊的是，有知情人士透露该up主曾在某次直播做菜活动中因无法应对突发状况而当场露馅，当时直播间观众超过50万人。那场直播回放目前已在社交平台疯传。</p>
    <blockquote><p>美食圈资深人士评论："现在很多美食博主都是团队包装出来的，真正会做菜的没几个。观众看到的精美画面背后，是庞大的制作团队和精心设计的剧本。"</p></blockquote>
    <p>事件曝光后，该up主的多个赞助品牌方已暂停合作。其粉丝数量在24小时内骤降超过80万。目前该up主已发布道歉视频，承认确实有团队协助拍摄，但否认所有内容均为摆拍。</p>`,
    category: 'zhubo-heiliao',
    author: '吃瓜前线记者',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20news%20reporter%20avatar%20portrait%20with%20neutral%20expression%20minimal%20dark%20background%20editorial%20style&width=80&height=80&seq=avatar-journalist-01&orientation=squarish',
    publishedAt: '2026-07-06T09:15:00Z',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20behind%20the%20scenes%20reveal%20of%20a%20fake%20cooking%20show%20with%20camera%20crew%20visible%20professional%20chef%20hiding%20behind%20set%20messy%20real%20kitchen%20contrast%20dark%20dramatic%20lighting%20cinematic%20expose&width=1600&height=900&seq=hero-cooking-fake&orientation=landscape',
    imagePrompt: 'A behind the scenes reveal of a fake cooking show with camera crew visible professional chef hiding behind set messy real kitchen contrast dark dramatic lighting cinematic expose',
    tags: ['B站', '美食博主', '摆拍', '造假'],
    views: 87500,
    comments: 2103,
    isHot: true,
    isBreaking: false,
  },
  {
    slug: 'douyu-geboshou-kaigua',
    title: '斗鱼顶流游戏主播被实锤开挂，直播画面出现透视外挂弹窗',
    excerpt: '斗鱼平台拥有800万关注的游戏主播在直播FPS游戏时，电脑屏幕意外弹出外挂程序的更新提示窗口，整个直播间瞬间炸锅...',
    content: `<p>斗鱼平台知名FPS游戏主播"枪神King"在昨晚的直播中遭遇了堪称史诗级的翻车现场。当时正在直播《CS:GO》排位赛的他，电脑屏幕上突然弹出了一个第三方外挂程序的自动更新提示窗口，整个过程被数万名在线观众亲眼目睹。</p>
    <p>弹窗内容显示"透视辅助v3.2已更新完毕，新增自动瞄准优化功能"。虽然主播在弹窗出现后的两秒钟内迅速切屏，但直播间截图已在社交平台疯传。多个技术分析账号对该截图进行了解析，确认该外挂程序确实为业内知名的游戏作弊工具。</p>
    <p>事后该主播在直播中极力辩解，声称是"朋友恶作剧"安装的程序，自己从未使用过。但这一说法显然无法让观众信服，大量粉丝在弹幕中打出"塌房"、"取关"等字样。</p>
    <blockquote><p>电竞圈知名评论员表示："FPS游戏开挂问题早已不是新鲜事，但像这样在直播中当场被抓现行的案例还是相当罕见。这对整个游戏直播行业的公信力都是沉重打击。"</p></blockquote>
    <p>斗鱼平台官方表示已对该主播展开调查，在调查期间将暂停其直播权限。同时，与该主播有合作关系的多家外设品牌方已宣布解除代言合约。</p>`,
    category: 'zhubo-heiliao',
    author: '电竞追踪者',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Esports%20journalist%20portrait%20young%20Chinese%20man%20with%20gaming%20headset%20dark%20minimal%20background%20professional%20headshot&width=80&height=80&seq=avatar-esports-03&orientation=squarish',
    publishedAt: '2026-07-05T22:00:00Z',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dark%20gaming%20room%20with%20computer%20screen%20showing%20hack%20program%20popup%20in%20red%20dramatic%20lighting%20reflecting%20on%20gamer%20face%20cinematic%20noir%20style%20high%20contrast%20moody%20atmosphere&width=1600&height=900&seq=hero-cheating-exposed&orientation=landscape',
    imagePrompt: 'Dark gaming room with computer screen showing hack program popup in red dramatic lighting reflecting on gamer face cinematic noir style high contrast moody atmosphere',
    tags: ['斗鱼', '游戏主播', '开挂', '实锤'],
    views: 152000,
    comments: 4567,
    isHot: true,
    isBreaking: true,
  },
  {
    slug: 'xiaohongshu-meizhuang-boshu-koubei',
    title: '小红书美妆博主被扒抄袭海外博主，连文案标点都一模一样',
    excerpt: '小红书拥有300万粉丝的美妆博主"CiCi酱"被网友发现其近半年来发布的30余篇笔记中，有超过20篇涉嫌抄袭多位海外美妆博主的内容...',
    content: `<p>小红书美妆区又出翻车事件！拥有超过300万粉丝的美妆博主"CiCi酱"近日被细心网友发现，其近半年来发布的大量美妆测评笔记与多位海外美妆博主的内容高度相似，甚至连排版格式和标点符号都如出一辙。</p>
    <p>有网友制作了详细的对比视频，将"CiCi酱"的笔记与海外博主的内容逐行比对，发现多处段落几乎是一字不差的翻译抄袭。更令人啼笑皆非的是，连海外博主在原文中使用的某些特定表达习惯和个人口头禅都被完整照搬。</p>
    <p>该博主在被曝光后迅速删除了大量争议笔记，但这一行为反而引发了更大的质疑。有网友调侃道："删得越快，说明越心虚。"</p>
    <blockquote><p>内容创作者联盟发表声明谴责此类抄袭行为，指出"这不仅侵犯了原创者的知识产权，也严重损害了整个内容创作行业的健康发展环境。"</p></blockquote>
    <p>目前，多个品牌合作方已暂停与该博主的合作。小红书平台也表示将对此事进行调查，如属实将对相关账号进行处理。</p>`,
    category: 'wanghong-tafang',
    author: '娱乐调查组',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Chinese%20investigative%20journalist%20portrait%20serious%20expression%20dark%20minimal%20background%20professional%20headshot&width=80&height=80&seq=avatar-investigator-02&orientation=squarish',
    publishedAt: '2026-07-05T14:20:00Z',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dark%20scene%20of%20two%20side%20by%20side%20phone%20screens%20showing%20identical%20social%20media%20posts%20with%20red%20highlighting%20on%20copied%20text%20dramatic%20lighting%20noir%20atmosphere&width=1600&height=900&seq=hero-plagiarism-scandal&orientation=landscape',
    imagePrompt: 'Dark scene of two side by side phone screens showing identical social media posts with red highlighting on copied text dramatic lighting noir atmosphere',
    tags: ['小红书', '美妆博主', '抄袭', '翻车'],
    views: 78300,
    comments: 1987,
    isHot: false,
    isBreaking: false,
  },
  {
    slug: 'weibo-zimeiti-zaoyao-dagua',
    title: '微博大V为博流量造谣某明星离婚，法院判决赔偿50万并公开道歉',
    excerpt: '微博某千万粉丝大V因发布某知名明星夫妇离婚的不实信息，被当事人起诉至法院。最终法院判决该大V赔偿50万元并连续置顶道歉30天...',
    content: `<p>微博某拥有千万粉丝的娱乐大V"八卦君"因编造并传播某知名明星夫妇离婚的虚假信息，被当事明星夫妇以侵犯名誉权为由起诉至法院。近日法院作出一审判决，判令该大V赔偿经济损失及精神损害抚慰金共计50万元，并在微博连续置顶道歉声明30天。</p>
    <p>据悉，该大V在今年3月发布多条微博，声称某明星夫妇已经秘密离婚，并详细描述了所谓的"离婚内幕"，包括财产分割、子女抚养等具体细节。该消息在发布后迅速扩散，阅读量超过2亿次，给当事明星造成了严重困扰。</p>
    <p>法院审理认为，该大V在没有任何事实依据的情况下，恶意编造并传播不实信息，其行为已构成对当事人名誉权的侵害，应承担相应的法律责任。</p>
    <blockquote><p>法律界人士指出："这起案件对整个自媒体行业都具有警示意义。造谣传谣不仅面临道德谴责，更要承担实实在在的法律后果。尤其是拥有大量粉丝的大V，更应该对自己的言论负责。"</p></blockquote>
    <p>该判决结果在社交平台引发广泛讨论，不少网友对此拍手称快，认为应该严惩造谣传谣者，净化网络空间。</p>`,
    category: 'meiri-dagua',
    author: '吃瓜前线记者',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20news%20reporter%20avatar%20portrait%20with%20neutral%20expression%20minimal%20dark%20background%20editorial%20style&width=80&height=80&seq=avatar-journalist-01&orientation=squarish',
    publishedAt: '2026-07-04T16:00:00Z',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dark%20dramatic%20courtroom%20scene%20with%20gavel%20and%20scales%20of%20justice%20with%20social%20media%20icons%20in%20red%20glow%20cinematic%20lighting%20noir%20atmosphere%20high%20contrast&width=1600&height=900&seq=hero-court-verdict&orientation=landscape',
    imagePrompt: 'Dark dramatic courtroom scene with gavel and scales of justice with social media icons in red glow cinematic lighting noir atmosphere high contrast',
    tags: ['微博', '造谣', '法院判决', '大V'],
    views: 110200,
    comments: 3210,
    isHot: true,
    isBreaking: false,
  },
  {
    slug: 'kuaishou-daizhubo-xianjing',
    title: '带货主播直播间"家人们"套路大揭秘：99元茅台实为9.9元勾兑酒',
    excerpt: '调查记者潜伏多个带货直播间三个月，发现大量主播使用虚构故事、虚假促销等手段诱导消费者购买劣质商品，"99元茅台"实际成本不到10元...',
    content: `<p>经过三个月的深入调查，本网记者揭露了直播带货行业中存在的一系列消费陷阱。其中最为典型的案例是，多个直播间销售的所谓"99元茅台"，实际上是成本不到10元的劣质勾兑白酒。</p>
    <p>调查发现，这些主播通常会编造各种感人的"厂家直销"故事，声称"为了回馈家人们"而"亏本销售"。他们会展示看似高端的包装礼盒，并用专业话术让消费者产生"捡到宝"的错觉。然而，经专业鉴定机构检测，这些所谓的名酒均不符合国家标准。</p>
    <blockquote><p>消费者权益保护协会专家提醒："直播购物要保持理性，不要被主播的煽情话术所迷惑。对于明显低于市场价的商品更要提高警惕，天上不会掉馅饼。"</p></blockquote>
    <p>该调查报告发布后引发强烈反响，多个涉事直播间的账号已被平台封禁。市场监管部门表示将对此类行为进行专项整治。</p>`,
    category: 'chigua-baoliao',
    author: '娱乐调查组',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Chinese%20investigative%20journalist%20portrait%20serious%20expression%20dark%20minimal%20background%20professional%20headshot&width=80&height=80&seq=avatar-investigator-02&orientation=squarish',
    publishedAt: '2026-07-04T08:00:00Z',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dark%20dramatic%20scene%20of%20luxury%20liquor%20bottles%20shattering%20on%20ground%20revealing%20cheap%20liquid%20inside%20with%20red%20warning%20signs%20cinematic%20noir%20atmosphere%20high%20contrast&width=1600&height=900&seq=hero-fake-products&orientation=landscape',
    imagePrompt: 'Dark dramatic scene of luxury liquor bottles shattering on ground revealing cheap liquid inside with red warning signs cinematic noir atmosphere high contrast',
    tags: ['带货', '套路', '消费陷阱', '调查'],
    views: 134600,
    comments: 3892,
    isHot: true,
    isBreaking: false,
  },
  {
    slug: 'douyin-zhubo-sirenjuxing',
    title: '抖音女主播"私人局"视频流出，尺度之大令网友直呼毁三观',
    excerpt: '一段据称是在某抖音女主播"私人局"上拍摄的视频在社交平台疯传，视频内容尺度令人震惊。该主播目前已清空所有社交账号内容...',
    content: `<p>近日，一段据称是在某抖音女主播"私人聚会"上拍摄的视频在多个社交平台广泛传播。视频内容涉及多位网红主播的不当行为，尺度之大令众多网友直呼"刷新三观"。</p>
    <p>据知情人士透露，该视频拍摄于上个月的一场私人派对上，参与人员均为直播行业从业者。视频的流出可能与参与者之间的内部矛盾有关，有人故意将视频泄露到社交平台。</p>
    <p>事件曝光后，涉事女主播已紧急清空所有社交平台内容，包括抖音、微博、小红书等账号均处于不可見状态。其经纪公司发布声明称已向公安机关报案，将追究恶意传播者法律责任。</p>
    <blockquote><p>社会学者评论："网红经济的野蛮生长导致部分从业者缺乏基本的职业操守和道德底线。在追逐流量的过程中，一些人正在不断突破社会的道德底线，这值得整个行业反思。"</p></blockquote>
    <p>平台方表示将配合有关部门进行调查，同时呼吁网友不要继续传播相关视频，共同维护清朗网络空间。</p>`,
    category: 'meiri-dagua',
    author: '吃瓜前线记者',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20news%20reporter%20avatar%20portrait%20with%20neutral%20expression%20minimal%20dark%20background%20editorial%20style&width=80&height=80&seq=avatar-journalist-01&orientation=squarish',
    publishedAt: '2026-07-03T20:30:00Z',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dark%20mysterious%20scene%20of%20a%20phone%20screen%20with%20blurred%20video%20playing%20in%20dark%20room%20with%20red%20ambient%20lighting%20dramatic%20shadows%20cinematic%20noir%20mysterious%20atmosphere&width=1600&height=900&seq=hero-private-party-leak&orientation=landscape',
    imagePrompt: 'Dark mysterious scene of a phone screen with blurred video playing in dark room with red ambient lighting dramatic shadows cinematic noir mysterious atmosphere',
    tags: ['抖音', '女主播', '视频流出', '热议'],
    views: 201300,
    comments: 5678,
    isHot: true,
    isBreaking: true,
  },
];

export const trendingArticles = articles.filter(a => a.isHot).slice(0, 6);

export const breakingNews = articles.filter(a => a.isBreaking).slice(0, 3);

export function getArticleBySlug(slug: string): Article | undefined {
  return articles.find(a => a.slug === slug);
}

export function getArticlesByCategory(categorySlug: string): Article[] {
  return articles.filter(a => a.category === categorySlug);
}

export function getRelatedArticles(article: Article, count: number = 3): Article[] {
  return articles
    .filter(a => a.slug !== article.slug && a.category === article.category)
    .slice(0, count);
}